export class GraphDataDto {
    barGraph: BarGraph[] = [];
    cumul_graph: number[][] = []; // list (size (mm); cumulative percentage)
  }
  
  // filepath: /c:/DTI/DEV/Explore/Explore-Front/src/app/models/bar-graph.ts
  export class BarGraph {
    start: number; // mm
    end: number; // mm
    value: number; // percentage
  
    constructor(start: number, end: number, value: number) {
      this.start = start;
      this.end = end;
      this.value = value;
    }
  }
  
  export class GraphData{
    sizes: number[] = [];
    percent : number[] = [];
    cumulPercent: number[] = [];
    rawCumulGraph: number[][] = [];
  }